import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { adminApi } from "../../../api-client";
import type { ReportStatus, UpdateReportStatus } from "../../../schemas/report";
import { queryKeys } from "../../query-keys";

export function useLocationReportsSummary(status: ReportStatus | "all" = "open") {
	return useQuery({
		queryKey: queryKeys.locationReports.summary(status),
		queryFn: () => adminApi.locations.reports.summary(status),
	});
}

export function useLocationReports(status: ReportStatus | "all" = "all") {
	return useQuery({
		queryKey: queryKeys.locationReports.list(status),
		queryFn: () => adminApi.locations.reports.list(status),
	});
}

export function useUpdateLocationReportStatus() {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: ({ id, body }: { id: string; body: UpdateReportStatus }) =>
			adminApi.locations.reports.updateStatus(id, body),
		onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.locationReports.all }),
	});
}
